// extracted by mini-css-extract-plugin
export default {"wrapper":"py-z","viewport":"qy-z","container":"ry-z","slide":"sy-z"};